import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { QuotationEntity } from './quotation.entity'

export class QuotationsRepository extends BaseRepository<QuotationEntity> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.posApiUrl + '/' + 'quotations', token, cache)
    }

    async upsert(dto: Partial<QuotationEntity>) {
        const { json, statusCode, message } = await this.request.post(
            this.config.posApiUrl + '/quotations/?token=' + this.resolvedToken,
            dto,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async setPaid(appointmentId: string, dto: { invoiceId: string }) {
        const { json, statusCode, message } = await this.request.patch(
            this.config.posApiUrl + '/quotations/' + appointmentId + '/paid/?token=' + this.resolvedToken,
            dto,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async setUnpaid(appointmentId: string) {
        const { json, statusCode, message } = await this.request.delete(
            this.config.posApiUrl + '/quotations/' + appointmentId + '/paid/?token=' + this.resolvedToken,
            {},
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
